import { render, staticRenderFns } from "./DepartmentOverviewCard.vue?vue&type=template&id=764cd896&scoped=true"
import script from "./DepartmentOverviewCard.vue?vue&type=script&lang=js"
export * from "./DepartmentOverviewCard.vue?vue&type=script&lang=js"
import style0 from "./DepartmentOverviewCard.vue?vue&type=style&index=0&id=764cd896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764cd896",
  null
  
)

export default component.exports